var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18C14.9 18 18.5 14.4 18.5 10C18.5 5.6 14.9 2 10.5 2C6.1 2 2.5 5.6 2.5 10C2.5 14.4 6.1 18 10.5 18ZM10.5 0C16 0 20.5 4.5 20.5 10C20.5 15.5 16 20 10.5 20C5 20 0.5 15.5 0.5 10C0.5 4.5 5 0 10.5 0ZM13.8 14.2L12.5 15L9.5 9.8V5H11V9.4L13.8 14.2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.cf7699cc.svg";
export { ForwardRef as ReactComponent };